import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Select } from "antd";

import css from "./MealCreateModal.module.css";
import { mealsService } from "../../../../services/settings-services";
import { mealsActions, menuCategoriesActions } from "../../../../store/slices/settings-slices";
import { getConfig } from "../../../../config";

const MealCreateModal = ({ setIsOpen }) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const { cityCode } = getConfig();
  const [selectedCategory, setSelectedCategory] = useState([]);

  const { menuCategories, trigger } = useSelector(
    (store) => store.menuCategories
  );

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();

  useEffect(() => {
    dispatch(menuCategoriesActions.getAllMenuCategories());
  }, [trigger, dispatch]);

  const handleCategoryChange = (values) => {
    setSelectedCategory(values);
  };

  const submitHandler = async (data) => {
    try {
      await mealsService.createMeals({ name: data, categories: selectedCategory });
      dispatch(mealsActions.changeTrigger());
      toast.success(t("modal-toast-settings-meal-successfully"));
      setIsOpen(false);
    } catch (error) {
      console.error(t("modal-toast-creating-error"), error);
      toast.error(t("modal-toast-creating-error"));
    }
  };

  return (
    <section className={css.wrap}>
      <div className={css.modal}>
        <button className={css.closeButton} onClick={() => setIsOpen(false)}>
          &times;
        </button>
        <h2 className={css.title}>{t("modal-settings-new-meal")}</h2>
        <form onSubmit={handleSubmit(submitHandler)}>
          <article className={css.inputGroup}>
            <label htmlFor="group">Group</label>
            <Select
              id="group"
              mode="multiple"
              value={selectedCategory}
              onChange={handleCategoryChange}
              placeholder="Select categories"
              style={{ width: '100%' }}
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              options={menuCategories?.map((obj) => ({
                value: obj.id,
                label: obj.name[currentLanguage] || obj.name["en"]
              })) || []}
            />
          </article>

          <article className={css.inputGroup}>
            <label htmlFor="en">
              {t("modal-name-input-new-category")} (English)
            </label>
            <input
              type="text"
              id="en"
              {...register("en", { required: "Name (English) is required" })}
              className={errors.en ? css.inputError : ""}
            />
            {errors.en && <p className={css.error}>{errors.en.message}</p>}
          </article>

          <article className={css.inputGroup}>
            <label htmlFor="ru">
              {t("modal-name-input-new-category")} (Русский)
            </label>
            <input
              type="text"
              id="ru"
              {...register("ru", { required: "Name (Русский) is required" })}
              className={errors.ru ? css.inputError : ""}
            />
            {errors.ru && <p className={css.error}>{errors.ru.message}</p>}
          </article>

          {cityCode === "UAE" ? (
            <>
              <article className={css.inputGroup}>
                <label htmlFor="ar">
                  {t("modal-name-input-new-category")} (العربية)
                </label>
                <input
                  type="text"
                  id="ar"
                  {...register("ar", {
                    required: "Name (العربية) is required",
                  })}
                  className={errors.ar ? css.inputError : ""}
                />
                {errors.ar && <p className={css.error}>{errors.ar.message}</p>}
              </article>
            </>
          ) : (
            <>
              <article className={css.inputGroup}>
                <label htmlFor="ge">
                  {t("modal-name-input-new-category")} (ქართული)
                </label>
                <input
                  type="text"
                  id="ge"
                  {...register("ge", {
                    required: "Name (ქართული) is required",
                  })}
                  className={errors.ge ? css.inputError : ""}
                />
                {errors.ge && <p className={css.error}>{errors.ge.message}</p>}
              </article>
            </>
          )}

          <button className={css.submitButton} disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Ok"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default MealCreateModal;
